import type { Flavour, RankId, TitleId } from '@aj/core';
import type { MessageKey } from '@aj/i18n';

/**
 * Rank and title names, in the register this student is owed.
 *
 * Two tiny functions rather than an inline template in every screen, because
 * the thing they prevent is real: a bare `rank.${id}` cast to `MessageKey`
 * typechecks perfectly and renders the literal string "rank.scholar" to the
 * user when the key set moves. Funnelling both through here means the key
 * shape is written down once, and one grep finds every place a name is read.
 *
 * The ids never change with flavour — only the words do. XP, thresholds and
 * every stored `rank.reached` event stay identical whichever register is in
 * force, which is what makes switching it safe at any point in a student's
 * life. See `flavour.ts`.
 */
export const rankKey = (flavour: Flavour, rank: RankId): MessageKey =>
  `rank.${flavour}.${rank}` as MessageKey;

export const titleKey = (flavour: Flavour, title: TitleId): MessageKey =>
  `title.${flavour}.${title}` as MessageKey;
